import { render, staticRenderFns } from "./picSelector.vue?vue&type=template&id=4639c8f8&scoped=true"
import script from "./picSelector.vue?vue&type=script&lang=js"
export * from "./picSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4639c8f8",
  null
  
)

export default component.exports